import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useStaticQuery, graphql } from 'gatsby';
import { Helmet } from 'react-helmet';
import { DFPSlotsProvider, DFPManager } from 'react-dfp';

import layoutStyles from './layout.module.styl';
import Header from './header';
import { adSettings } from '../../content/main.json';
import { homepage } from '../../package.json';

import '../styles/stylus/base.styl';

// This is needed for the web fonts defined in gatsby-config.js to load.
import '../styles/stylus/fonts.styl';
import getPageTargetingArguments from '../lib/getPageTargetingArguments';

const Layout = ({
  children, className, pageTitle, path, socialText,
}) => {
  const data = useStaticQuery(graphql`
      query SiteTitleQuery {
          site {
              siteMetadata {
                  title
                  siteName
              }
          }
      }
  `);

  const pageTargetingArguments = getPageTargetingArguments({
    adSettings,
    keywords: [],
    url: `${homepage}${path}`,
  });
  DFPManager.setTargetingArguments(pageTargetingArguments);

  return (
    <DFPSlotsProvider
      dfpNetworkId={adSettings.networkId}
      adUnit={adSettings.unit}
    >
      <Helmet
        bodyAttributes={{ class: className }}
      >
        <title>
          {`${pageTitle || data.site.siteMetadata.title} - ${data.site.siteMetadata.siteName}`}
        </title>
      </Helmet>
      <Header pageTitle={pageTitle} socialText={socialText} />
      <main id="content">
        {children}
      </main>
      {/* Hack to prevent the overlap mentioned in ARC-3008, first comment. */}
      {path !== '/' && (
        <footer>
          <p className={classNames('bentoncond-n4', layoutStyles.copyright)}>
            © 2021 Boston Globe Media Partners, LLC
          </p>
        </footer>
      )}
    </DFPSlotsProvider>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  pageTitle: PropTypes.string,
  socialText: PropTypes.string,
  path: PropTypes.string.isRequired,
};

Layout.defaultProps = {
  className: '',
  pageTitle: null,
  socialText: null,
};

export default Layout;
